module.exports = {
  publicPath: '/',
  chainWebpack: config => {
    //发布模式
    config.when(process.env.NODE_ENV === 'production', config => {
      config
        .entry('app')
        .clear()
        .add('./src/main.js')
      config.set('externals', {})
      config.plugin('html').tap(args => {
        args[0].isProd = true
        return args
      })
    })
    //开发模式
    config.when(process.env.NODE_ENV === 'development', config => {
      config
        .entry('app')
        .clear()
        .add('./src/main.js')
      config.plugin('html').tap(args => {
        args[0].isProd = false
        return args
      })
    })
  },
  devServer: {
    host: '0.0.0.0',
    port: 8080, // 端口号
    https: false, // https:{type:Boolean}
    open: true, //配置自动启动浏览器
    proxy: {
      '/company': {
        target: process.env.VUE_APP_COMPANY_PROXY_TARGET,
        ws: true,
        changOrigin: true,
        pathRewrite: {
          '/api': process.env.VUE_APP_COMPANY_PATH_REWRITE
        }
      },
      '/OPM': {
        target: process.env.VUE_APP_OPM_PROXY_TARGET,
        changOrigin: true,
        pathRewrite: {
          '/api': ''
        }
      }
    }
  }
}
